module.exports = __webpack_public_path__ + "img/container_ui.c97ef333.png";